import React from 'react';
import * as dates from 'date-arithmetic';
import TimeGrid from 'react-big-calendar/lib/TimeGrid';
import { defaultDate, minDate, maxDate } from '../../util/TimeTableUtil';

class ScheduleWeek extends React.Component {
    render() {
        let {
            date,
            localizer,
            min = { minDate },
            max = { maxDate },
            scrollToTime = localizer.startOf(defaultDate, 'day'),
        } = this.props;
        let range = ScheduleWeek.range(date, { localizer });

        return (
            <TimeGrid
                {...this.props}
                range={range}
                eventOffset={0}
                localizer={localizer}
                min={min}
                max={max}
                scrollToTime={scrollToTime}
            />
        );
    }
}

ScheduleWeek.range = (date, { localizer }) => {
    let start = defaultDate;
    let end = dates.add(start, 4, 'day');

    let current = start;
    let range = [];

    while (localizer.lte(current, end, 'day')) {
        range.push(current);
        current = localizer.add(current, 1, 'day');
    }

    return range;
};

ScheduleWeek.title = (date) => {
    return `${date.toLocaleDateString()}`;
};

export default ScheduleWeek;
